import { render } from "./SkillsGroeiChart.vue?vue&type=template&id=23b35630&scoped=true"
import script from "./SkillsGroeiChart.vue?vue&type=script&lang=js"
export * from "./SkillsGroeiChart.vue?vue&type=script&lang=js"

import "./SkillsGroeiChart.vue?vue&type=style&index=0&id=23b35630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b35630"]])

export default __exports__